<template>
  <div class="container h-100">
    <div class="row h-100">
      <!-- col-lg-3 -->
      <div class="col-lg-3"></div>
      <!-- col-lg-3 fine -->
      <!-- col-lg-6 -->
      <div class="col-lg-6">
        <div class="consent mt-5">
          <div class="consent__box" v-show="agreement !== {}">
            <h2 class="consent__agreement-title ms-5">{{ nameOfAgreement }}</h2>
            <div style="padding: 0 2.5rem">
              <editor
                :tools="[]"
                :immutables="true"
                ref="editorReadonlyConsent"
                :value="htmlConsentDoc"
                style="height: 39rem"
                rows="30"
                cols="30"
                class="w-100 mt-3"
              >
              </editor>
            </div>
            <h5 class="ms-5 mt-4 consent__question">
              Would you like to update your previous consent?
            </h5>
            <form @submit.prevent="updateConsents" ref="snippet">
              <div
                style="padding: 0 2.5rem"
                v-for="(item, index) in labels"
                :key="index"
              >
                <div>
                  <input
                    class="new-agreement__form-check"
                    type="checkbox"
                    :id="`agreement_${index}`"
                    :checked="item.accepted"
                    :required="item.label.required"
                    :data-agreement="item.label.guid"
                    :disabled="item.label.required"
                    aria-label="Checkbox for following text input"
                    @click="isFormChanged()"
                  />
                  <label
                    :for="`agreement_${index}`"
                    class="new-agreement__form-labels-check"
                    :style="{
                      cursor: item.label.required ? 'default' : 'pointer',
                    }"
                  >
                    <span
                      class="new-agreement__form-check--btn me-3"
                      @click="isFormChanged()"
                      :class="{
                        'new-agreement__form-check--btn-disabled':
                          item.label.required,
                      }"
                    ></span>
                    {{ item.label.label.text }}
                    <template>
                      <sup
                        ><small
                          class="ms-3"
                          style="color: var(--color-main); font-weight: 700"
                          v-if="item.label.required"
                          >* required</small
                        ></sup
                      >
                    </template>
                  </label>
                </div>
              </div>
              <button
                type="submit"
                class="nam_btn_sm nam_btn_primario mt-4 ms-auto"
                id="submit"
              >
                Renew consent
              </button>
            </form>
          </div>
        </div>
      </div>
      <!-- col-lg-6 fine -->
      <!-- col-lg-3 -->
      <div class="col-lg-3"></div>
      <!-- col-lg-3 fine -->
    </div>
  </div>
</template>

<script>
import "@progress/kendo-ui";
import { Editor } from "@progress/kendo-editor-vue-wrapper";
import html2canvas from 'html2canvas'

import { http } from "../interceptor/http";

export default {
  name: "Consent",
  components: {
    editor: Editor,
  },
  data() {
    return {
      agreement: {},
      consent: [],
      labels: [],
      isFormValid:[],
      title: "",
      documentName: "",
      documentGuid: "",
      htmlConsentDoc: "",
      nameOfAgreement: "",
      allowScreenshotRenew:false
    };
  },
  mounted() {
    this.InitApplication();
  },
  methods: {
    InitApplication(){
      if (this.IsContentEditable()) {
      this.$refs.editorReadonlyConsent.$el.parentElement.firstChild.contentDocument.documentElement.children[1].contentEditable =
        "false";
      this.GetConsent();
      this. isFormChanged();
    }
    },
    async IsContentEditable() {
      const loader = this.$loading.show();
      try {
        let params = new URLSearchParams([
          ["consentGuid", this.$route.params.id],
        ]);
        const request = await http.get(`/Consent/IsConsentEditable`, {
          params,
        });

        loader.hide();
        return await request.data;
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    async GetConsent() {
      const loader = this.$loading.show();
      try {
        let params = new URLSearchParams([
          ["consentGuid", this.$route.params.id],
        ]);

        const request = await http.post(`/Consent/GetLastConsentModification`, {},{ params });
        const response = await request.data;

        const { agreement, labels, ...consent } = response;

        this.consent = consent;

        params = new URLSearchParams([
          ["groupGuid", agreement.groupGuid],
          ["enviroment", agreement.enviroment],
        ]);

        const requestRecentAgreement = await http.get(
          "/Agreement/LastEnviromentVersion",
          { params }
        );

        const responseRecentAgreement = await requestRecentAgreement.data;

        this.agreement = responseRecentAgreement;

        this.title = responseRecentAgreement.titleTranslation.text;

        this.nameOfAgreement = this.agreement.nameOfAgreement;

        this.allowScreenshotRenew = this.agreement.allowScreenshot;

        this.documentGuid = responseRecentAgreement.documents[0].guid;

        this.documentName = responseRecentAgreement.documents[0].documentName;

        this.htmlConsentDoc = responseRecentAgreement.documents[0].document;

        const { labels: labelsRecentAgreement } = this.agreement;

        loader.hide();
        this.ElaborateLabels(labels, labelsRecentAgreement);
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    ElaborateLabels(labels, labelsRecentAgreement) {
      const recentTags = labelsRecentAgreement.map((recent) => recent.tag);
      const oldTags = labels.map((old) => old.label.tag);

      const verifyNewLabel = recentTags.filter(
        (recent) => oldTags.indexOf(recent) === -1
      );

      const verifyLabelNotPresent = oldTags.filter(
        (old) => recentTags.indexOf(old) === -1
      );

      if (verifyLabelNotPresent.length > 0) {
        for (let y = 0; y < verifyLabelNotPresent.length; y++) {
          const tagNotPresent = verifyLabelNotPresent[y];

          const elementIndex = labels.findIndex(
            (x) => x.label.tag === tagNotPresent
          );

          labels.splice(elementIndex, 1);
        }
      }

      if (verifyNewLabel.length > 0) {
        for (let x = 0; x < verifyNewLabel.length; x++) {
          let el = verifyNewLabel[x];

          const newLabel = labelsRecentAgreement.find((x) => x.tag === el);

          let entity = {
            accepted: false,
            label: newLabel,
          };

          labels.push(entity);
        }


        this.labels = labels;
      } else {
        this.labels = labels;
      }
    },
    async updateConsents() {
      const loader = this.$loading.show();
      try {
        let labels = [];
        const { trustedReferrer, externalID, fieldCollection, consentGroupGuid } = this.consent;
        Array.from(this.$refs.snippet.querySelectorAll("input")).forEach(
          (checkbox) => {
            labels.push({
              agreementLabelGuid: checkbox.dataset.agreement,
              accepted: checkbox.checked,
            });
          }
        );

        let screenshot = [];
        
        if( this.allowScreenshotRenew ){
          let imageScreen = await this.GenerateSnapshotConsent();
          screenshot = this.GenerateArrayOfBytes(imageScreen.toDataURL("image/png"));
        }


        const params = new URLSearchParams([
          ["agreementGuid", this.agreement.guid],
        ]);

        const entity = {
          fieldCollection,
          externalID,
          labels,
          trustedReferrer,
          consentGroupGuid,
          screenshot
        };

        const request = await http.post("/Consent/UpdateConsent", entity, { params });

        if( request.status === 200 ) {
          this.$router.replace({name:"200"});
        }
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    isFormChanged(){
      this.isFormValid = [];
      if (!this.$el) return;
      for (let index = 0; index < this.labels.length; index++) {
        if(!this.labels[index].label.required) {
          this.isFormValid.push(this.$el.querySelector(`#agreement_${index}`).checked === this.labels[index].accepted );
        }
      }
      
      if( this.isFormValid.every( x => x === true) ){
        this.$el.querySelector("#submit").setAttribute( "disabled", "disabled" );
      } else {
        this.$el.querySelector("#submit").removeAttribute( "disabled", false);
      }
    },
    GenerateArrayOfBytes( base64String) {
      let binary_string = window.atob(base64String.split(",")[1]);
      let lenghtString = binary_string.length;
      let arrOfByte = [];
      for (let x = 0; x < lenghtString; x++) {
        arrOfByte[x] = binary_string.charCodeAt(x);
      }

      return arrOfByte;
    },
    GenerateSnapshotConsent() {
      return html2canvas(document.documentElement, {
        allowTaint: true
      });
    },
  }
};
</script>

<style lang="sass"></style>
